import { useInfiniteQuery } from 'react-query';
import { AuthContext } from '../../Context/AuthContext';
import { useContext } from 'react';

const fetchMerchants = async ({ pageParam = 1, token }) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/users/merchants?page=${pageParam}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Error fetching merchants. Please try again.');
  }

  return response.json();
};

const useMerchants = () => {
  const { token } = useContext(AuthContext);

  return useInfiniteQuery(
    'merchants',
    ({ pageParam = 1 }) => fetchMerchants({ pageParam, token }),
    {
      enabled: !!token,
      getNextPageParam: (lastPage) => {
        const nextPage = (lastPage.currentPage || 1) + 1;
        const totalPages = lastPage.totalPages || Math.ceil((lastPage.totalMerchants || 0) / (lastPage.limit || 10));
        return nextPage <= totalPages ? nextPage : undefined;
      },
    }
  );
};

export default useMerchants;

